var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extraLarge":"","title":"Listagem de pacientes","buttons":['cancel']}},[_c('rkm-row',[_c('rkm-col',[_c('List',{attrs:{"item":_vm.item,"origem":"coleta"},on:{"exit":_vm.exit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }